import {BetaSchemaForm} from '@ant-design/pro-form'

export * from '@ant-design/pro-card'
export * from '@ant-design/pro-descriptions'
export * from '@ant-design/pro-field'
export * from '@ant-design/pro-form'
export * from '@ant-design/pro-layout'
export * from '@ant-design/pro-list'
export * from '@ant-design/pro-provider'
export * from '@ant-design/pro-skeleton'
export * from '@ant-design/pro-table'
export * from '@ant-design/pro-utils'
export const SchemaForm = BetaSchemaForm
